"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.User = void 0;
const Photo_1 = require("./Photo");
const CommonDto_1 = require("../dto/CommonDto");
class User {
    constructor(name, email, code, avatar, domain, metrikaId, created, updated) {
        this.name = name;
        this.email = email;
        this.code = code;
        this.avatar = avatar;
        this.domain = domain;
        this.metrikaId = metrikaId;
        this.created = created;
        this.updated = updated;
    }
    static fromDto(dto) {
        return new User(dto.name ? dto.name : "", dto.email ? dto.email : "", dto.code ? dto.code : "", dto.avatar && dto.avatar.type === CommonDto_1.PhotoType.PHOTO ? Photo_1.Photo.fromDto(dto.avatar) : null, dto.domain ? dto.domain : "", dto.metrikaId ? dto.metrikaId : 0, dto.created, dto.updated);
    }
}
exports.User = User;
